import TCard from './card.vue'

TCard.install = Vue => {
  Vue.component(TCard.name, TCard)
}

export default TCard



// WEBPACK FOOTER //
// ./src/module/card/index.js